import * as THREE from 'three';
import { memorialEmblem } from './memorial-emblem.js';
import { weatheredMaterial } from './prop-detail.js';

/** Six different memorial silhouettes; the original carved headstone remains style zero. */
export function addSecondaryGrave(group: THREE.Group, variant: number) {
  const stone=weatheredMaterial([0x908778,0x9a8e7c,0x786e66,0x8e8371,0x797d79,0x6a5444][variant-1],'stone',{flatShading:true});
  const dark=new THREE.MeshStandardMaterial({color:0x484742,roughness:1}), moss=new THREE.MeshStandardMaterial({color:0x536143,roughness:1});
  const wood=weatheredMaterial(0x645044,'wood');
  const add=(geo:THREE.BufferGeometry,x:number,y:number,z:number,mat:THREE.Material=stone)=>{const mesh=new THREE.Mesh(geo,mat);mesh.position.set(x,y,z);mesh.castShadow=mesh.receiveShadow=true;group.add(mesh);return mesh;};
  const box=(w:number,h:number,d:number,x:number,y:number,z:number,mat:THREE.Material=stone)=>add(new THREE.BoxGeometry(w,h,d),x,y,z,mat);
  const carve=(w:number,y:number,z=.147)=>box(w,.026,.012,0,y,z,dark);
  const tablet=(shape:THREE.Shape,depth:number,x:number,y:number,z:number)=>add(new THREE.ExtrudeGeometry(shape,{depth,bevelEnabled:true,bevelSize:.018,bevelThickness:.015,bevelSegments:1,steps:1}),x,y,z);
  box(.85,.13,1.8,0,.065,.42);
  switch(variant){
    case 1: { // Diamond-shaped memorial on a stepped pedestal.
      box(.62,.16,.5,0,.21,-.3); box(.2,.58,.22,0,.56,-.3);
      const head = new THREE.Shape(); head.moveTo(0,.51); head.lineTo(.46,0); head.lineTo(0,-.51); head.lineTo(-.46,0); head.closePath();
      tablet(head,.22,0,1.24,-.42);
      const emblem = memorialEmblem(dark,.67,.78,.028); emblem.position.set(0,1.24,-.18); group.add(emblem);
      break;
    }
    case 2: { // Rounded tablet with a recessed dedication and small wreath.
      const outline=new THREE.Shape();outline.moveTo(-.38,0);outline.lineTo(.38,0);outline.lineTo(.38,.86);outline.absarc(0,.86,.38,0,Math.PI,false);outline.closePath();tablet(outline,.24,0,.14,-.42);
      box(.59,.54,.014,0,.57,-.163,dark);box(.52,.47,.015,0,.57,-.15,stone);
      add(new THREE.TorusGeometry(.14,.022,5,16),0,1.07,-.163,moss);for(const y of [.43,.54,.65]) carve(.3,y,-.13);
      break;
    }
    case 3: // Raised chest tomb with a bevelled lid and ornamental corner feet.
      box(.77,.49,1.46,0,.38,.45);box(.9,.13,1.63,0,.7,.45);box(.78,.07,1.46,0,.8,.45);
      for(const x of [-.33,.33])for(const z of [-.17,1.07])box(.15,.3,.18,x,.18,z);
      const lidEmblem=memorialEmblem(dark,.43,.63,.026); lidEmblem.position.set(0,.842,.45); lidEmblem.rotation.x=-Math.PI/2; group.add(lidEmblem);
      for(const z of [.1,.5,.9])box(.014,.25,.025,.395,.4,z,dark);
      break;
    case 4: { // Snapped headstone with its lost crown lying beside the grave.
      const shape=new THREE.Shape();shape.moveTo(-.34,0);shape.lineTo(.34,0);shape.lineTo(.34,.83);shape.lineTo(.15,.71);shape.lineTo(.06,.9);shape.lineTo(-.12,.73);shape.lineTo(-.34,.85);shape.closePath();
      tablet(shape,.22,0,.13,-.43).rotation.z=-.08;for(const y of [.36,.46,.56])carve(.31,y,-.197);
      const chip=box(.58,.19,.32,.2,.18,.92);chip.rotation.set(.1,.5,.18);
      box(.15,.09,.13,-.32,.13,.55).rotation.y=.8;
      break;
    }
    case 5: // Narrow tapered monument and pyramidal finial.
      box(.65,.2,.54,0,.25,-.3);add(new THREE.CylinderGeometry(.18,.31,1.19,4),0,.95,-.3).rotation.y=Math.PI/4;
      add(new THREE.ConeGeometry(.255,.4,4),0,1.74,-.3).rotation.y=Math.PI/4;
      const monumentEmblem=memorialEmblem(dark,.16,.26,.012); monumentEmblem.position.set(0,1.15,-.139); monumentEmblem.rotation.x=-.077; group.add(monumentEmblem);
      break;
    case 6: { // A humble diamond plaque carried by one timber post above an earth mound.
      box(.14,.83,.16,0,.47,-.3,wood);
      const plaque=new THREE.Shape(); plaque.moveTo(0,.39); plaque.lineTo(.34,0); plaque.lineTo(0,-.39); plaque.lineTo(-.34,0); plaque.closePath();
      add(new THREE.ExtrudeGeometry(plaque,{depth:.12,bevelEnabled:true,bevelSize:.02,bevelThickness:.015,bevelSegments:1}),0,1.17,-.36,wood);
      const emblem=memorialEmblem(dark,.46,.55,.022); emblem.position.set(0,1.17,-.22); group.add(emblem);
      add(new THREE.SphereGeometry(1,12,6),0,.15,.55,weatheredMaterial(0x655647,'stone')).scale.set(.34,.16,.67);
      break;
    }
  }
  // Small, flat moss islands grow at joints, never floating in front of carvings.
  for(let i=0;i<7;i++){const patch=add(new THREE.IcosahedronGeometry(.08+i%3*.018,0),Math.sin(i*2.4)*.28,.14,.2+i*.16,moss);patch.scale.set(1.3,.1,1);}
}
